import { Grid, Box, Button, IconButton } from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import { FormSelect } from "../form-elements/FormSelect";
import { FormTextField } from "../form-elements/FormTextField";

export const NewListingForm = ({
  formData,
  handleChange,
  entries,
  handleEntryChange,
  addNewEntry,
  removeEntry,
  generalMessage,
  handleGeneralMessageChange,
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <FormTextField
          label="Full Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          placeholder="Full Name"
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <FormTextField
          label="Email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          required
          placeholder="Enter your email so we can reach you if needed"
        />
      </Grid>

      {entries.map((entry, index) => (
        <Grid item xs={12} key={entry.id}>
          <Box
            sx={{
              p: 4,
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              position: "relative",
            }}
          >
            {entries.length > 1 && (
              <IconButton
                onClick={() => removeEntry(entry.id)}
                sx={{
                  position: "absolute",
                  top: 1,
                  right: 1,
                  color: "error.main",
                }}
              >
                <Delete />
              </IconButton>
            )}

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormSelect
                  label="What type of information would you like to add?"
                  name="errorType"
                  value={entry.errorType || ""}
                  onChange={(e) => handleEntryChange(e, index)}
                  options={[
                    { value: "Enumber", label: "E-Number" },
                    { value: "Restaurant", label: "Restaurant" },
                    { value: "Mosque", label: "Mosque" },
                  ]}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <FormTextField
                  label="Location/Name"
                  name="location"
                  value={entry.location || ""}
                  onChange={(e) => handleEntryChange(e, index)}
                  required
                  placeholder="Name or location of the place"
                />
              </Grid>

              <Grid item xs={12}>
                <FormTextField
                  label="Additional Details"
                  name="details"
                  value={entry.details || ""}
                  onChange={(e) => handleEntryChange(e, index)}
                  multiline
                  rows={4}
                  required
                  placeholder="Link to a website or source we can verify"
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      ))}

      <Grid item xs={12}>
        <Button
          variant="outlined"
          startIcon={<Add />}
          onClick={addNewEntry}
          sx={{
            color: "#00171f",
            borderColor: "#00171f",
            "&:hover": {
              backgroundColor: "#00171f",
              color: "#fff",
              borderColor: "#00171f",
            },
            borderRadius: 2,
            padding: "7px 10px",
            fontSize: "1rem",
            boxShadow: "none",
            width: "auto",
            mt: 3,
          }}
        >
          Add Another Listing
        </Button>
      </Grid>

      <Grid item xs={12}>
        <FormTextField
          label="Message for us (optional)"
          name="generalMessage"
          value={generalMessage}
          onChange={handleGeneralMessageChange}
          multiline
          rows={3}
          fullWidth
          placeholder="Write your message here..."
        />
      </Grid>
    </Grid>
  );
};
